import Vue from 'vue'
import App from './App.vue'
import Login from './Login.vue'
// import './registerServiceWorker'
//import store from './store'
import vuetify from './plugins/vuetify'

//import router from './router'
import VueRouter from 'vue-router'
import routes from './router'
import api from '@/api'

Vue.config.productionTip = false

//Vue.prototype.$apiEndpoint = window.location.href.includes('10.8.0.4') ? 'http://10.8.0.4/~crocodylus/da-api/' : 'http://localhost/~crocodylus/da-api/'

const themeMixin = {
  data: () => ({
    theme: { header: 'grey--text text--darken-2' },
  })
}

let user = localStorage.getItem('user') || {}
let token = localStorage.getItem('token') || ''

const runMain = () => {
  Vue.use(VueRouter)
  const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
  })

  new Vue({
    data: () => ({
      user,
    }),
    computed: {
      isAuthenticated () {
        return !!this.user.token
      },
    },
    router,
  //  store,
    vuetify,
    render: h => h(App)
  }).$mount('#app')
}

const runLogin = () => {
  new Vue({
    vuetify,
    render: h => h(Login)
  }).$mount('#app')
}

if ( token )
{
  api.get('account/ping').then(response => {
    if ( response.data.$result === 'ok' )
    {
      runMain()
    }
    else if ( response.data.$result === 'unauth' )
    {
      localStorage.removeItem('token')
      runLogin()
    }
    else
    {
      alert(response.data.data)
    }
  }).catch(error => {
    alert(error)
  })
}
else
{
  runLogin()
}
